<div class="flex-container">
  <div>
    <h2>Grupo Nutricional</h2>
    <p class="paragraph">Acompanhe a alimentação do seu filho seguindo os padrões da alimentação saudável. Confira a tabela abaixo da classificação
      nutricional, verificando o volume de produtos consumidos conforme a pirâmide alimentar. Atenção caso haja um grande
      volume de produtos consumidos que pertencem ao grupo do topo da pirâmide.
      <a (click)="desc()">Saiba mais</a>
      <!-- <a href="assets/images/pyramid_description.pdf" target="_system">Saiba mais</a> -->
    </p>
  </div>
</div>

<div class="flex-container">
  <div>
    <h2>Pirâmide Nutricional</h2>
    <img class="img-responsive" src="assets/images/food_pyramid.png"> 
    <!-- <p>Clique aqui e saiba mais sobre a pirâmide alimentar!</p> -->
  </div>
</div>

<div>
  <h2 class="h2edit">Comparativo</h2>
  <br>
  <div class="grafico-container container">
    <app-dash-graphic [dependentId]="dependentId" [companyId]="companyId"></app-dash-graphic>
    <div class="subtitle">
      <div class="max">
        <p class="tl">
          <b>Legenda</b>
        </p>
        <p>
          <b class="tl">0</b> - Não Classificado
          <b class="tl">1</b> - Doces
          <b class="tl">2</b> - Cereais
          <b class="tl">3</b> - Laticínios
          <b class="tl">4</b> - Sucos
          <b class="tl">5</b> - Frutas
          <b class="tl">6</b> - Carboidratos
          <b class="tl">7</b> - Frituras</p>
        <!-- <p>0 - Não Classificado   1 - Doces  2 - Cereais  3 - Laticínios  4 - Sucos 5 - Frutas 6 - Carboidratos 7 - Frituras</p> -->
      </div>
      <div class="min">
        <p class="tl">
          <b>Legenda</b>
        </p>
        <p>
          <b class="tl">0</b> - Não Classificado
          <br>
          <b class="tl">1</b> - Doces
          <br>
          <b class="tl">2</b> - Cereais
          <br>
          <b class="tl">3</b> - Laticínios
          <br>
          <b class="tl">4</b> - Sucos
          <br>
          <b class="tl">5</b> - Frutas
          <br>
          <b class="tl">6</b> - Carboidratos
          <br>
          <b class="tl">7</b> - Frituras</p>
      </div>

    </div>
  </div>
  <!-- <chart [type]="type" [data]="data" [options]="options"></chart> -->
</div>

<div class="flex-container">
  <div>
    <h2>Valor Nutricional</h2>
    <p class="paragraph">Auxilie seu filho a ter uma alimentação saudável, mantendo alimentos de bom a ótimo valor nutricional e restringindo
      os alimentos de pior valor. A alimentação na fase infantil, impacta diretamente no crescimento e desenvolvimento da
      criança.
      <!-- <a
        href="assets/images/pyramid_description.pdf" target="_blank"> Saiba mais</a> -->
    </p>
  </div>
</div>

<div class="flex-container">
  <div>
    <h2>Classificação Nutricional</h2>
    <img class="img-responsive" src="assets/images/nutritional-group.png">
    <!-- <p>Clique aqui e saiba mais sobre classificações alimentares!</p> -->
  </div>
</div>

<div class="flex-container">
    <div>
      <h2>Valor Nutricional</h2>
      <p class="paragraph">Auxilie seu filho a ter uma alimentação saudável, mantendo alimentos de bom a ótimo valor nutricional e restringindo
        os alimentos de pior valor. A alimentação na fase infantil, impacta diretamente no crescimento e desenvolvimento da
        criança.
      </p>
    </div>
  </div>

<div>
  <h2 class="h2edit">Comparativo</h2>
  <br>
  <div class="grafico-container container">
    <div class="chartjs-render-monitor">
    <app-nutritional-group></app-nutritional-group>
  </div>
    <div class="subtitle">
      <div class="max">
        <p class="tl">
          <b>Legenda</b>
        </p>
        <p>
          <b class="tl">0</b> - Não Classificado
          <b class="tl">1</b> - Excelente
          <b class="tl">2</b> - Bom
          <b class="tl">3</b> - Regular
          <b class="tl">4</b> - Ruim
      </div>
      <div class="min">
        <p class="tl">
          <b>Legenda</b>
        </p>
        <p>
          <b class="tl">0</b> - Não Classificado
          <br>
          <b class="tl">1</b> - Excelente
          <br>
          <b class="tl">2</b> - Bom
          <br>
          <b class="tl">3</b> - Regular
          <br>
          <b class="tl">4</b> - Ruim
          <br>
      </div>

    </div>

  </div>
  <br>
  <br>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/nutritional/nutritional.component.html